/**
 * Tier 2 — DeFi and admin flows.
 *
 * These are pure on-chain: their post-confirmation work is refetching pool
 * state and updating local UI, never a debt owed to the backend. So they get
 * journal coverage (reload-survivable pending/success/failed state) and no
 * outbox.
 *
 * They also use the *imperative* `writeContractAsync` shape rather than the
 * declarative hook pair. That needs nothing special from the engine — the
 * persistent hook journals on the same code path for both, because the intent
 * is recorded before the call either way.
 *
 * No on-chain verifiers except for approvals. A swap or a pool initialisation
 * cannot be identified after the fact from chain state alone — reserves move
 * for everyone's trades, not just ours — so recovery resolves these by hash
 * with the bounded nonce scan behind it.
 */

import { registerFlow } from "../flows";
import { approveSatisfied } from "../verifiers";

export const SWAP_FLOW = "v4Swap";
export const SWAP_STEPS = { APPROVE: "approve", SWAP: "swap" };

export const POOL_FLOW = "v4Pool";
export const POOL_STEPS = {
  INITIALIZE: "initialize",
  REGISTER: "register",
  UPDATE_STATE: "updatePoolState",
  APPROVE: "approve",
};

export const LIQUIDITY_FLOW = "v4Liquidity";
export const LIQUIDITY_STEPS = { DEPOSIT: "deposit", WITHDRAW: "withdraw" };

export const ADMIN_FLOW = "adminHook";
export const ADMIN_STEPS = { PAUSE: "setPoolPaused", CONTROL: "hookControl" };

registerFlow({
  id: SWAP_FLOW,
  steps: {
    [SWAP_STEPS.APPROVE]: { verifyOnChain: approveSatisfied },
    [SWAP_STEPS.SWAP]: {},
  },
});

registerFlow({
  id: POOL_FLOW,
  steps: {
    [POOL_STEPS.INITIALIZE]: {},
    [POOL_STEPS.REGISTER]: {},
    [POOL_STEPS.UPDATE_STATE]: {},
    [POOL_STEPS.APPROVE]: { verifyOnChain: approveSatisfied },
  },
});

registerFlow({
  id: LIQUIDITY_FLOW,
  steps: { [LIQUIDITY_STEPS.DEPOSIT]: {}, [LIQUIDITY_STEPS.WITHDRAW]: {} },
});

registerFlow({
  id: ADMIN_FLOW,
  steps: { [ADMIN_STEPS.PAUSE]: {}, [ADMIN_STEPS.CONTROL]: {} },
});
